import { InlineText3 } from '@cian/ui-kit';
import * as React from 'react';

interface IPromotionCostProps {
  promotionCost: number;
}

export const PromotionCost = ({ promotionCost }: IPromotionCostProps) => {
  return <InlineText3 color="gray60_100">С учётом пакета {promotionCost} ₽/день</InlineText3>;
};
